/**
 * Dictionnaire des pays — recopié depuis `crm_countries.rs` du Mac.
 *
 * `crm_countries` est la seule table CRM volontairement ABSENTE du miroir
 * (cf. MultiDeviceImplementation.md) : c'est un dictionnaire semé à
 * l'identique des deux côtés, le synchroniser n'apporterait rien. La PWA en
 * porte donc sa propre copie, générée depuis la même source pour que les
 * codes ISO concordent exactement.
 *
 * Régénérer après toute modification du seed Rust.
 */

export interface Country {
  code: string;
  name: string;
  flag: string;
  eu: boolean;
}

/**
 * Les pays qui reviennent le plus dans le portefeuille, en accès direct.
 * Ordre issu de la répartition réelle des sociétés — le reste passe par le
 * sélecteur.
 */
export const FREQUENT_COUNTRIES = ["FR", "DE", "NL", "ES", "BE", "IT", "LU", "PL"];

export const COUNTRIES: Country[] = [
  { code: "FR", name: "France", flag: "🇫🇷", eu: true },
  { code: "DE", name: "Allemagne", flag: "🇩🇪", eu: true },
  { code: "IT", name: "Italie", flag: "🇮🇹", eu: true },
  { code: "ES", name: "Espagne", flag: "🇪🇸", eu: true },
  { code: "PT", name: "Portugal", flag: "🇵🇹", eu: true },
  { code: "BE", name: "Belgique", flag: "🇧🇪", eu: true },
  { code: "NL", name: "Pays-Bas", flag: "🇳🇱", eu: true },
  { code: "LU", name: "Luxembourg", flag: "🇱🇺", eu: true },
  { code: "IE", name: "Irlande", flag: "🇮🇪", eu: true },
  { code: "AT", name: "Autriche", flag: "🇦🇹", eu: true },
  { code: "DK", name: "Danemark", flag: "🇩🇰", eu: true },
  { code: "SE", name: "Suède", flag: "🇸🇪", eu: true },
  { code: "FI", name: "Finlande", flag: "🇫🇮", eu: true },
  { code: "EE", name: "Estonie", flag: "🇪🇪", eu: true },
  { code: "LV", name: "Lettonie", flag: "🇱🇻", eu: true },
  { code: "LT", name: "Lituanie", flag: "🇱🇹", eu: true },
  { code: "PL", name: "Pologne", flag: "🇵🇱", eu: true },
  { code: "CZ", name: "Tchéquie", flag: "🇨🇿", eu: true },
  { code: "SK", name: "Slovaquie", flag: "🇸🇰", eu: true },
  { code: "HU", name: "Hongrie", flag: "🇭🇺", eu: true },
  { code: "SI", name: "Slovénie", flag: "🇸🇮", eu: true },
  { code: "HR", name: "Croatie", flag: "🇭🇷", eu: true },
  { code: "RO", name: "Roumanie", flag: "🇷🇴", eu: true },
  { code: "BG", name: "Bulgarie", flag: "🇧🇬", eu: true },
  { code: "GR", name: "Grèce", flag: "🇬🇷", eu: true },
  { code: "CY", name: "Chypre", flag: "🇨🇾", eu: true },
  { code: "MT", name: "Malte", flag: "🇲🇹", eu: true },
  { code: "GB", name: "Royaume-Uni", flag: "🇬🇧", eu: false },
  { code: "CH", name: "Suisse", flag: "🇨🇭", eu: false },
  { code: "NO", name: "Norvège", flag: "🇳🇴", eu: false },
  { code: "IS", name: "Islande", flag: "🇮🇸", eu: false },
  { code: "LI", name: "Liechtenstein", flag: "🇱🇮", eu: false },
  { code: "MC", name: "Monaco", flag: "🇲🇨", eu: false },
  { code: "AD", name: "Andorre", flag: "🇦🇩", eu: false },
  { code: "SM", name: "Saint-Marin", flag: "🇸🇲", eu: false },
  { code: "VA", name: "Vatican", flag: "🇻🇦", eu: false },
  { code: "RU", name: "Russie", flag: "🇷🇺", eu: false },
  { code: "UA", name: "Ukraine", flag: "🇺🇦", eu: false },
  { code: "BY", name: "Biélorussie", flag: "🇧🇾", eu: false },
  { code: "MD", name: "Moldavie", flag: "🇲🇩", eu: false },
  { code: "RS", name: "Serbie", flag: "🇷🇸", eu: false },
  { code: "ME", name: "Monténégro", flag: "🇲🇪", eu: false },
  { code: "MK", name: "Macédoine du Nord", flag: "🇲🇰", eu: false },
  { code: "BA", name: "Bosnie-Herzégovine", flag: "🇧🇦", eu: false },
  { code: "AL", name: "Albanie", flag: "🇦🇱", eu: false },
  { code: "XK", name: "Kosovo", flag: "🇽🇰", eu: false },
  { code: "TR", name: "Turquie", flag: "🇹🇷", eu: false },
  { code: "US", name: "États-Unis", flag: "🇺🇸", eu: false },
  { code: "CA", name: "Canada", flag: "🇨🇦", eu: false },
  { code: "MX", name: "Mexique", flag: "🇲🇽", eu: false },
  { code: "BR", name: "Brésil", flag: "🇧🇷", eu: false },
  { code: "AR", name: "Argentine", flag: "🇦🇷", eu: false },
  { code: "CL", name: "Chili", flag: "🇨🇱", eu: false },
  { code: "CO", name: "Colombie", flag: "🇨🇴", eu: false },
  { code: "PE", name: "Pérou", flag: "🇵🇪", eu: false },
  { code: "IL", name: "Israël", flag: "🇮🇱", eu: false },
  { code: "AE", name: "Émirats arabes unis", flag: "🇦🇪", eu: false },
  { code: "SA", name: "Arabie saoudite", flag: "🇸🇦", eu: false },
  { code: "QA", name: "Qatar", flag: "🇶🇦", eu: false },
  { code: "KW", name: "Koweït", flag: "🇰🇼", eu: false },
  { code: "BH", name: "Bahreïn", flag: "🇧🇭", eu: false },
  { code: "OM", name: "Oman", flag: "🇴🇲", eu: false },
  { code: "LB", name: "Liban", flag: "🇱🇧", eu: false },
  { code: "JO", name: "Jordanie", flag: "🇯🇴", eu: false },
  { code: "MA", name: "Maroc", flag: "🇲🇦", eu: false },
  { code: "DZ", name: "Algérie", flag: "🇩🇿", eu: false },
  { code: "TN", name: "Tunisie", flag: "🇹🇳", eu: false },
  { code: "EG", name: "Égypte", flag: "🇪🇬", eu: false },
  { code: "ZA", name: "Afrique du Sud", flag: "🇿🇦", eu: false },
  { code: "NG", name: "Nigéria", flag: "🇳🇬", eu: false },
  { code: "KE", name: "Kenya", flag: "🇰🇪", eu: false },
  { code: "CI", name: "Côte d'Ivoire", flag: "🇨🇮", eu: false },
  { code: "SN", name: "Sénégal", flag: "🇸🇳", eu: false },
  { code: "CN", name: "Chine", flag: "🇨🇳", eu: false },
  { code: "JP", name: "Japon", flag: "🇯🇵", eu: false },
  { code: "KR", name: "Corée du Sud", flag: "🇰🇷", eu: false },
  { code: "IN", name: "Inde", flag: "🇮🇳", eu: false },
  { code: "TH", name: "Thaïlande", flag: "🇹🇭", eu: false },
  { code: "VN", name: "Viêt Nam", flag: "🇻🇳", eu: false },
  { code: "MY", name: "Malaisie", flag: "🇲🇾", eu: false },
  { code: "SG", name: "Singapour", flag: "🇸🇬", eu: false },
  { code: "PH", name: "Philippines", flag: "🇵🇭", eu: false },
  { code: "ID", name: "Indonésie", flag: "🇮🇩", eu: false },
  { code: "TW", name: "Taïwan", flag: "🇹🇼", eu: false },
  { code: "HK", name: "Hong Kong", flag: "🇭🇰", eu: false },
  { code: "PK", name: "Pakistan", flag: "🇵🇰", eu: false },
  { code: "BD", name: "Bangladesh", flag: "🇧🇩", eu: false },
  { code: "AU", name: "Australie", flag: "🇦🇺", eu: false },
  { code: "NZ", name: "Nouvelle-Zélande", flag: "🇳🇿", eu: false },
];

const BY_CODE = new Map(COUNTRIES.map((c) => [c.code, c]));

export function country(code: string | null | undefined): Country | null {
  if (!code) return null;
  return BY_CODE.get(code.toUpperCase()) ?? null;
}

/** « 🇫🇷 France », ou le code brut si le dictionnaire ne le connaît pas. */
export function countryLabel(code: string | null | undefined): string {
  if (!code) return "";
  const c = country(code);
  return c ? `${c.flag} ${c.name}` : code;
}

/** UE d'abord (le gros du négoce), puis alphabétique — comme côté Mac. */
export const COUNTRIES_SORTED: Country[] = [...COUNTRIES].sort(
  (a, b) => Number(b.eu) - Number(a.eu) || a.name.localeCompare(b.name, "fr"),
);
